<template>
      <main>
        <div class="container-fluid">
          <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="activity-hour-content-tab" data-bs-toggle="pill" data-bs-target="#activity-hour-content"
                type="button" role="tab" aria-controls="activity-hour-content" aria-selected="true"> 分時查詢 </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="intergrate-content-tab" data-bs-toggle="pill" data-bs-target="#intergrate-content" 
                type="button" role="tab" aria-controls="intergrate-content" aria-selected="false"> 綜合查詢 </button>
            </li>
          </ul>

          <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
            <search-by-hours></search-by-hours>
            <integrate-search></integrate-search>
          </div>
        </div>
      </main>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import searchByHours from "./searchByHours.vue";
import integrateSearch from './integrateSearch.vue'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import { getCountPerDay } from '../../api/elasticSearch/peopleApis'

export default {
  components: { searchByHours, integrateSearch },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('hour').format(),
      dataTableList: [],
    };
  },
  computed: {
  },
  watch: {

  },
  methods: {
  },
  async mounted() {

  }
};
</script>